import type React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { BlockWrapper, useBlockPaletteFactory } from '../common';
import { BlockVariantContext } from '../contexts';

/**
 * Component to render a quote block.
 */
export function BlockQuote(props: BlockProps): React.ReactElement {
    const { children, node } = props;
    const palette = useBlockPaletteFactory({ nodeKey: node.key, aiCompletion: true });

    return (
        <BlockWrapper tag="blockquote" {...props} palette={palette}>
            <div className="border-l-4 pr-4 pl-8">
                <div className="relative flex flex-col text-muted">
                    <BlockVariantContext.Provider value="quote">
                        {children}
                    </BlockVariantContext.Provider>
                </div>
            </div>
        </BlockWrapper>
    );
}
